import { useContext } from "react";

import ThemeContext, { TThemeVariant } from "./ThemeContext";

export default (variant?: TThemeVariant): TThemeVariant => {
  const context = useContext(ThemeContext);
  return variant || (context ? context.variant : "light");
};
